import store from "../store"

const CHAT_SERVICE = process.env.VUE_APP_HOST;

const request = (options) => {
    const headers = new Headers();

    if (options.setContentType !== false) {
        headers.append("Content-Type", "application/json");
    }

    if (store.state.auth.status.loggedIn) {
        headers.append(
            "Authorization",
            "Bearer " + store.state.auth.user.token
        );
    }

    const defaults = { headers: headers };
    options = Object.assign({}, defaults, options);

    return fetch(options.url, options).then((response) =>
        response.json().then((json) => {
            if (!response.ok) {
                return Promise.reject(json);
            }
            return json;
        })
    );
};


export function countNewMessages(senderId, recipientId) {
    if (!store.state.auth.status.loggedIn) {
        return Promise.reject("No access token set.");
    }

    return request({
        url: CHAT_SERVICE + "/messages/" + senderId + "/" + recipientId + "/count",
        method: "GET",
    });
}

export function findChatMessages(senderId, recipientId) {
    if (!store.state.auth.status.loggedIn) {
        return Promise.reject("No access token set.");
    }
    console.log("Sender Id = "+senderId)

    return request({
        url: CHAT_SERVICE + "/messages/" + senderId + "/" + recipientId,
        method: "GET",
    });
}
export function findChatMessagesPagable(senderId, recipientId,page) {
    if (!store.state.auth.status.loggedIn) {
        return Promise.reject("No access token set.");
    }
    console.log("Sender Id = "+senderId)

    return request({
        url: CHAT_SERVICE + "/messages/" + senderId + "/" + recipientId+ "/" + page,
        method: "GET",
    });
}

export function findChatMessage(id) {
    if (!store.state.auth.status.loggedIn) {
        return Promise.reject("No access token set.");
    }
    console.log("ID______________:"+id);
    return request({
        url: CHAT_SERVICE + "/messages/" + id,
        method: "GET",
    });
}